import React from 'react'
import { Row, Button, ConfigProvider } from 'antd'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'
import { useNavigate } from 'react-router-dom'

const Inner = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transform: translateY(-20%);
`

const Ohoh = styled.h1`
    color: var(--primary);
    font-size: 44px;
    margin: 8px;

    span {
        transform: translateY(-4px);
        display: inline-block;
    }
`

const Message = styled.h2`
`

const fullScreenStyle = css`
    background: linear-gradient(180deg, #4B718E 0%, #051633 100%);
    color: white;
    height: 100vh;
    width: 100vw;

    ${Ohoh}, ${Message} {
        color: white;
    }
`

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ fullScreen }) => (fullScreen ? fullScreenStyle : '')}
    min-height: 500px;
`

export default function ErrorContent (props) {
  const { status = '404', fullScreen = false } = props
  const { t: ln_t } = useTranslation()
  const navigate = useNavigate()
  return (
    <Wrapper fullScreen={fullScreen}>
      <Inner>
        <ConfigProvider theme={{ token: { colorPrimary: 'rgb(71, 182, 175)', colorPrimaryHover: 'rgba(71, 182, 175,.8)' } }}>
          <Ohoh>Oh Oh <span>: (</span></Ohoh>
          <Message>{ln_t(`error.page.${status}`)}</Message>
          {status === '502'
            ? <Button type="primary" className="mt-4 mr-2" onClick={() => navigate('/')}>Try Again</Button>
            : <Row className="mt-4 mr-2">
                <Button type="button" className="mr-2" onClick={() => navigate(-1)}>Go Back</Button>
                <Button type="primary" onClick={() => window.location.reload(false)}>Reload</Button>
              </Row>}
        </ConfigProvider>
      </Inner>
    </Wrapper>
  )
}
